import { Database } from "@/lib/supabase";
import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { createContext, useContext } from "react";

export const PatientFormContext = createContext<{
	formData: Database["public"]["Tables"]["patients"]["Row"];
	formErrors: Record<string, string | null>;
	setFormErrors: React.Dispatch<React.SetStateAction<Record<string, string | null>>>;
	handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleValueChange: (name: string, value: any) => void;
	handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	withinSheet: boolean;
	isUpdate: boolean;
	onSave: (patient: PatientEntityType) => void;
	submitRef?: React.LegacyRef<HTMLButtonElement>;
	setIsPendingChanges: (isPendingChanges: boolean) => void;
	patientId: string | undefined;
	openExtended: boolean;
} | null>(null);

export const usePatientForm = () => {
	const context = useContext(PatientFormContext);
	if (!context)
		throw new Error("usePatientForm must be used within <PatientForm>");
	return context;
};
